import React from "react";

export const FIELDS_TOUR_STORAGE_KEY = "tourSeen";

export function hasSeenTour() {
  try {
    return localStorage.getItem(FIELDS_TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function markTourSeen() {
  try {
    localStorage.setItem(FIELDS_TOUR_STORAGE_KEY, "1");
  } catch {
    // private mode / blocked storage
  }
}

export const tourSteps = [
  {
    target: '[data-tour="pdf-controls-fields"]',
    content: (
      <div className="tour-tooltip-content">
        Show or hide fields on the badge with the eye icon
        <br />
        <br />
        Edit values for each attendee field if needed
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="badge-editor-canvas-column"]',
    content: (
      <div className="tour-tooltip-content">
        Preview and edit your badge design
        <br />
        <br />
        Use the toolbar above for fonts, colors, and alignment
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="badge-editor-controls"]',
    content: (
      <div className="tour-tooltip-content">
        Add shapes, static text, images, a static QR code or barcode
      </div>
    ),
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="pdf-controls-top"]',
    content: (
      <div className="tour-tooltip-content">
        Preview the badge for every imported attendee
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="pdf-controls-download"]',
    content: (
      <div className="tour-tooltip-content">
        When you are ready, generate and download PDF badges for the imported
        attendees
      </div>
    ),
    placement: 'left',
    disableBeacon: true,
  },
];
